
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();


export const getActions = async (spanOfDays = 0, isOverDue = 0) => {
    let spanOfDaysQs = '';
    if( parseInt(spanOfDays) > 0){
      spanOfDaysQs = `?spanOfDays=${spanOfDays}`;
    }

    let isOverDueQs = '';
    if(isOverDue == 1){
        if(spanOfDaysQs.length>0){
            isOverDueQs = `&isOverDue=1`
        }
        if(spanOfDaysQs.length == 0){
            isOverDueQs = `?isOverDue=1`
        }
    }

   

    const response = await authenticatedFetch(`${config.API_BASE_URL}/actions${spanOfDaysQs}${isOverDueQs}`, {
        method: 'GET',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        return responseData; 
      } else {
        throw new Error(`Error fetching actions`);
      }
};



export const getActionsTotalNumber = async (spanOfDays = 0, isOverDue = 0) => {
  let spanOfDaysQs = '';
  if( parseInt(spanOfDays) > 0){
    spanOfDaysQs = `&spanOfDays=${spanOfDays}`;
  }
  let isOverDueQs = '';
  if(isOverDue == 1){
    isOverDueQs = `&isOverDue=1`
  }

 

  const response = await authenticatedFetch(`${config.API_BASE_URL}/actions?returnTotalOnly=1${spanOfDaysQs}${isOverDueQs}`, {
      method: 'GET',
      headers: {
      
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      }
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData; 
    } else {
      throw new Error(`Error fetching actions total number`);
    }
};